import { toast } from "react-toastify";

import axios from "axios";

import { API_URL } from "../modules/auth/constants";
import { DASHBOARD } from "../modules/dashboard/routes";
import history from "../routes/history";
import { store } from "../store";

const Axios = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
  },
});

Axios.interceptors.request.use((request) => {
  const { authReducer } = store.getState();
  if (authReducer?.token) {
    request.headers.Authorization = `Bearer ${authReducer.token}`;
  }
  return request;
});

Axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    } else {
      if (error.response.status === 403) {
        localStorage.clear();
        history.push(DASHBOARD);
        toast.error("Redirection: Vous n'avez pas les droits");
      }
      if (error.response.status === 401) {
        localStorage.clear();
        history.go(0);
        toast.error(error.response?.data?.message || "Déconnexion");
      }
      return Promise.reject(error);
    }
  },
);

export default Axios;
